module.exports = __webpack_public_path__ + "0d332f864643f0a3a074981082571d5e.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/face/consumers/images/intro-bg.png
// module id = 896
// module chunks = 3